import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["data-testid"];

var _templateObject;

import React from 'react';
import { DatePicker as AntDatePicker } from 'antd';
import styled from 'styled-components';
var StyledDatePicker = styled(AntDatePicker).attrs(function (_ref) {
  var placeholder = _ref.placeholder;
  return {
    placeholder: placeholder || ''
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.ant-picker {\n    width: 100%;\n\n    &.ant-picker-focused {\n      box-shadow: none;\n    }\n  }\n"])));

function DatePicker(props) {
  var dataTestId = props['data-testid'],
      otherProps = _objectWithoutProperties(props, _excluded);

  var panelRender = function panelRender(PanelNode) {
    return dataTestId ? /*#__PURE__*/React.createElement("div", {
      "data-testid": "".concat(dataTestId, "Panel")
    }, PanelNode) : PanelNode;
  };

  return /*#__PURE__*/React.createElement(StyledDatePicker, _extends({
    "data-testid": dataTestId,
    panelRender: panelRender
  }, otherProps));
}

DatePicker.WeekPicker = AntDatePicker.WeekPicker;
DatePicker.MonthPicker = AntDatePicker.MonthPicker;
DatePicker.YearPicker = AntDatePicker.YearPicker;
DatePicker.RangePicker = AntDatePicker.RangePicker;
DatePicker.TimePicker = AntDatePicker.TimePicker;
DatePicker.QuarterPicker = AntDatePicker.QuarterPicker;
export default DatePicker;